import React, { FunctionComponent } from "react"

import ConfirmModal, { IConfirmModalProps } from "components/ConfirmModal/ConfirmModal"
import { useTranslation } from "react-i18next"

export interface IDataLossWarningModalProps extends Omit<IConfirmModalProps, "onConfirm" | "onClose"> {
    onClose(): void
    onConfirm(): void
}

const DataLossWarningModal: FunctionComponent<React.PropsWithChildren<IDataLossWarningModalProps>> = ({
    onClose,
    onConfirm,
    children,
    ...rest
}) => {
    const { t } = useTranslation()

    return (
        <ConfirmModal
            theme="danger"
            title={t('common.warning')}
            maxWidth="640px"
            onClose={onClose}
            onConfirm={onConfirm}
            cancelButtonLabel={t('common.goBack')}
            confirmButtonLabel={t('common.leavePage')}
            {...rest}>
            {!!children ? children : t('common.leaveConfirm')}
        </ConfirmModal>
    )
}

export default DataLossWarningModal
